// Remove the file after cluster migration
import ApiClient from 'api-client/ApiClient'
import store from 'app/store'
import { groupByRegion } from 'api-client/Keystone'
import { isDevelopment, isLocalhost } from 'core/utils/helpers'
import config from 'app-config'

// Get the Infra Region FQDN
export const getInfraRegionURL = () => {
  const { session } = store.getState()
  const { isSingleRegionDeployment } = session

  if (isSingleRegionDeployment) {
    if (isDevelopment() || isLocalhost()) {
      return config.apiHost || ''
    }
    return window?.location?.origin || ''
  }

  const { serviceCatalog } = ApiClient.getInstance()
  const servicesByRegion = groupByRegion(serviceCatalog)
  const resmgrEndpoint = servicesByRegion?.['Infra']?.resmgr?.public?.url
  const baseUrl = resmgrEndpoint?.split('/resmgr')?.[0]
  return baseUrl || ''
}

export enum ApplicationCredentialType {
  IdentityRef = 'identityRef', // User-tenant Level
  SshKeyName = 'sshKey',
}

export const getApplicationSecretName = (type) => {
  const { session } = store.getState()
  const {
    userDetails: { email },
    activeKaapiTenant,
    activeRegion,
  } = session

  if (type === ApplicationCredentialType.IdentityRef) {
    const username = email.split('@')[0].replaceAll(/[. ]/g, '-')
    if (!activeKaapiTenant || !username) return ''

    return String(`pf9-id-ref-${activeRegion}`).toLowerCase()
  }
  return String(`pf9-ssh-${activeKaapiTenant}`).toLowerCase()
}
